import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../reducer/LoginReducer/LoginReducer";
import forgetPasswordReducer from "../reducer/ForgetPasswordReducer/ForgetPasswordReducer";
import inspectorReducer from "../reducer/InspectorManagement/AddInspectorReducer";
import adminProfileReducer from "../reducer/AdminProfile/AdminProfileReducer";
import projectReducer from "../reducer/ManageProject/ManageProjectReducer";
import masterReducer from "../reducer/MasterReducer/MasterReducer";
import inspectionDetailReducer from "../reducer/InspectonDetailReducer/InspectionDetailReducer";
import DashboardReducer from "../reducer/DashboardReducer/DashboardReducer";
import inspectionFilterReducer from "../reducer/FilterReducer/InspectionFilterReducer";
import dataVerificationReducer from "../reducer/DataVerification/DataVerificationTable"
import notificationReducer from "../reducer/NotificationReducer/NotificationReducer";
import globalSearchReducer from "../reducer/GlobalSearchReducer/GlobalSearchReducer";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    forgetPassword: forgetPasswordReducer,
    inspector: inspectorReducer,
    profile: adminProfileReducer,
    project: projectReducer,
    master: masterReducer,
    inspectionDetails: inspectionDetailReducer,
    dashboard: DashboardReducer,
    inspectionfilter: inspectionFilterReducer,
    dataVerification: dataVerificationReducer,
    notification: notificationReducer,
    globalSearch: globalSearchReducer,
  },
});
